var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("button", { staticClass: "button", attrs: { id: "open-dialog-map" } }, [
      _vm._v(_vm._s(_vm.$t("projectmap.label.filtersort"))),
    ]),
    _vm._v(" "),
    _c(
      "dialog",
      { attrs: { id: "dialog-map" } },
      [
        _vm._m(0),
        _vm._v(" "),
        _c("h6", { staticClass: "u-extra-medium-margin--top" }, [
          _vm._v(_vm._s(_vm.$t("projectmap.label.filtersort"))),
        ]),
        _vm._v(" "),
        _vm._l(_vm.layerFilterItemsCheckboxes, function (object, index) {
          return _c("v-project-map-asphalt-sort-checkbox-item", {
            key: index,
            attrs: { asphaltType: object },
            on: { activeChanged: _vm.onChangeFilterLayers },
          })
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      { staticClass: "close-button", attrs: { id: "close-dialog-map" } },
      [
        _c("span", { staticClass: "show-for-sr" }, [_vm._v("Schließen")]),
        _vm._v(" "),
        _c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("x")]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }